import { makeStyles } from '@material-ui/styles'
import { isAdmin } from 'app/plugins/infrastructure/components/common/helpers'
import Badge from 'core/elements/badge'
import IconButton from 'core/elements/button/IconButton'
import OverviewActions from 'core/elements/overview/OverviewActions'
import colors from 'core/themes/base/colors'
import Theme from 'core/themes/model'
import EllipsisText from 'k8s/components/common/EllipsisText'
import React, { useState } from 'react'
import { defaultAppIconPath } from '../constant'
import FailedStatusDetailsDialog from '../FailedStatusDetailsDialog'
import { appStatus, getAppStatus, getResourceDetails, useBreakpointMatch } from '../helper'
import InfoBadge from '../InfoBadge'
import InfoBox from '../InfoBox'
import RowInfo from '../RowInfo'

const AppCardView = ({
  iconName,
  headerName,
  templateName,
  vms,
  status,
  version,
  ownerName,
  overviewActions,
  handleClick,
  isIconView = false,
  data,
}) => {
  const classes = useStyles()
  const { label, variant } = getAppStatus(status)
  const isBelowCustom = useBreakpointMatch(1700)
  const [showFailedDetails, setShowFailedDetails] = useState(false)

  const resourceDetails = getResourceDetails(data)

  const templateDetails = [
    {
      label: 'Template',
      value: templateName,
      imagePath: '',
      showDivider: true,
    },
    {
      label: 'Owner',
      value: ownerName,
      imagePath: '',
      showDivider: false,
    },
  ]
  return (
    <>
      {showFailedDetails && data && (
        <FailedStatusDetailsDialog
          rows={[data]}
          onClose={() => {
            setShowFailedDetails(false)
          }}
        />
      )}
      <div className={classes.cardContainer}>
        <div className={classes.headerContainer}>
          <div className={classes.iconsContainer}>
            <div>
              <img src={iconName || defaultAppIconPath} className={classes.iconWrapper} />
            </div>

            <div className={classes.headerText}>
              <EllipsisText
                title={headerName}
                showTooltip={true}
                maxWidth={isBelowCustom ? 220 : undefined}
                variant="subtitle2"
              >
                {headerName}
              </EllipsisText>
              <div className={classes.statusContainer}>
                <InfoBadge
                  variant={variant}
                  label={label}
                  onInfoClick={() => setShowFailedDetails(true)}
                  showInfo={label === 'Failed' || label === 'Delete Failed'}
                />
                <Badge className={classes.badge} variant={appStatus.Default} text={`${vms} VMs`} />
              </div>
            </div>
          </div>
          {isAdmin() && (
            <IconButton
              size="md"
              icon="ellipsis-vertical"
              solid={true}
              className={classes.settingsMenuButton}
              onClick={handleClick}
            />
          )}
        </div>
        <div className={classes.subTextContainer}>
          {resourceDetails?.map((item, index) => (
            <InfoBox
              label={item?.label}
              value={item?.value}
              imagePath={item?.imagePath}
              showDivider={item?.showDivider}
            />
          ))}
        </div>
        <div className={classes.headerText}>
          {templateDetails?.map((item) => (
            <RowInfo label={item?.label} value={item?.value} />
          ))}
        </div>
        <div>
          {overviewActions && (
            <OverviewActions
              actions={overviewActions}
              entity={{}}
              isIconOnly={isIconView}
              className={isIconView && classes.customButton}
            />
          )}
        </div>
      </div>
    </>
  )
}
export default AppCardView

const useStyles = makeStyles<Theme>((theme) => ({
  cardContainer: {
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: 4,
    padding: theme.spacing(3),
    background: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  subContainer: {
    display: 'grid',
    gap: theme.spacing(1),
    margin: theme.spacing(3, 0, 3, 0),
  },
  subTextContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  subText: {
    minWidth: 65,
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid ${theme.palette.grey[200]}`,
    width: theme.spacing(4),
    height: theme.spacing(4),
    rotate: '90deg',
    '& i': {
      color: theme.palette.grey[500],
    },
    cursor: 'pointer',
  },
  iconsContainer: {
    display: 'flex',
    gap: 16,
    alignItems: 'center',
  },
  iconWrapper: {
    width: 56,
    height: 56,
  },
  headerText: {
    display: 'grid',
    gap: theme.spacing(1),
    minWidth: 0,
    flexGrow: 1,
  },
  statusContainer: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  settingsMenuButton: {
    '&:hover': {
      backgroundColor: colors.grey[200],
    },
  },
  badge: {
    backgroundColor: '#FAFAFC',
    borderColor: '1px solid #E6E6EA',
  },
  customButton: {
    '& button': {
      width: 36,
    },
    '& .button-text': {
      gap: 0,
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
    },
  },
}))
